<header class="hvac-accordion-label hvac-h4">
    <ng-content></ng-content>
</header>
